const binding = { modules: {}, dataActions: {} };

    (binding.modules['ext-html-block'] = {
        c: () => require('partner/modules/ext-html-block/ext-html-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ext-html-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ext-html-block'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ext-html-block|ext-html-block'] = {
                c: () => require('partner/modules/ext-html-block/ext-html-block.view.tsx'),
                cn: '__local__-__local__-ext-html-block'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };